// extracted by css-extract-rspack-plugin
export default {"cls1":"BottomSection-cls1_jVl","cls2":"BottomSection-cls2_DmK BottomSection-cls1_jVl"};